// 用户消息
export default {
  path: 'notice',
  component: () => import('@/layout/Empty.vue'),
  children: [
    {
      path: '/letter',
      name: 'letterCenter',
      component: () => import('@/views/user/letter/LetterCenter'),
      redirect: 'all',
      children: [
        //全部消息
        {
          path: 'all',
          name: 'All',
          component: () => import('@/views/user/letter/All')
        },
        //未读
        {
          path: 'un-read',
          name: 'UnRead',
          component: () => import('@/views/user/letter/UnRead')
        },
        //已读
        {
          path: 'have-read',
          name: 'HaveRead',
          component: () => import('@/views/user/letter/HaveRead')
        },
        //催办
        {
          path: 'urge',
          name: 'Urge',
          component: () => import('@/views/user/letter/Urge')
        },
        //催办
        {
          path: 'system',
          name: 'System',
          component: () => import('@/views/user/letter/System')
        },
        //版本消息
        {
          path: 'version',
          name: 'Version',
          component: () => import('@/views/user/letter/Version')
        },
        //其他消息
        {
          path: 'other',
          name: 'Other',
          component: () => import('@/views/user/letter/Other')
        }
      ]
    }
  ]
}
